<template>
  <div class="main-container">
    <loading :isShow="listLoading" />
    <Button type="primary" class="btn export" @click="exportDetailData">导出本页费用明细</Button>
    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>

    <div class="statistics-container">
      <div class="statistics-item">
        <div class="item">
          基础费用合计：
          <span class="num">{{ data.commissionPrice }}</span
          >元
        </div>
        <div class="item">
          业务员基础费用合计：
          <span class="num">{{ data.commissionPriceByUser }}</span
          >元
        </div>
        <div class="item">
          团队长管理费合计：
          <span class="num">{{ data.commissionPriceByGroup }}</span
          >元
        </div>
      </div>
    </div>

    <div class="table">
      <div class="tr tr-first">
        <div class="td">
          <span>投保件数：{{ data.insureNum }}</span>
        </div>
        <div class="td">
          <span>投保保费：￥{{ data.insureFee }}</span>
        </div>
        <div class="td">
          <span>投保费用：￥{{ data.insureCommissionPrice }}</span>
        </div>
        <div class="td"></div>
        <div class="td"></div>
      </div>

      <div class="tr">
        <div class="td">
          <span>批单件数：{{ data.billNum }}</span>
        </div>
        <div class="td">
          <span>加保保费：￥{{ data.billAddFee }}</span>
        </div>
        <div class="td">
          <span>加保费用：￥{{ data.billAddCommissionPrice }}</span>
        </div>
        <div class="td">
          <span>减保保费：￥{{ data.billSubFee }}</span>
        </div>
        <div class="td">
          <span>减保费用：￥{{ data.billSubCommissionPrice }}</span>
        </div>
      </div>

      <div class="tr">
        <div class="td">
          <span>退保件数：{{ data.refundNum }}</span>
        </div>
        <div class="td">
          <span>退保保费：￥{{ data.refundFee }}</span>
        </div>
        <div class="td">
          <span>退保费用：￥{{ data.refundCommissionPrice }}</span>
        </div>
        <div class="td"></div>
        <div class="td"></div>
      </div>
    </div>

    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="userName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0 || row.isSus == 1 }"></i>
              <span class="user-name">{{ row.owerStaffNo }}/{{ row.owerName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="commissionPrice">
          <div class="commission-price">
            <span>{{ row.commissionPrice }}</span>
            <div class="text-tag" v-if="row.isDeduct == 1">扣款</div>
          </div>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import filter from '@/api/filter';
import { common, pageTool } from '@/api/mixins';
export default {
  mixins: [common, pageTool],
  data() {
    return {
      reportId: null,
      tabVal: null,
      orgId: null,
      userId: null,
      data: {},
      tableData: [],
      columns: [],
      columns2: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        },
        {
          title: '业务员',
          align: 'center',
          key: 'owerName',
          minWidth: 160,
          slot: 'userName_staffNo'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let settlementStatus = params.row.settlementStatus;
            if (settlementStatus == 1) {
              return <span>已结算</span>;
            } else {
              return <span>待结算</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '起保日期',
          align: 'center',
          key: 'startTime',
          minWidth: 130,
          render(h, params) {
            let startTime = params.row.startTime;
            return <span>{filter.filterTime(startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '终保日期',
          align: 'center',
          key: 'endTime',
          minWidth: 130,
          render(h, params) {
            let endTime = params.row.endTime;
            return <span>{filter.filterTime(endTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '原保单承保日期',
          align: 'center',
          key: 'originalIssueTime',
          minWidth: 130,
          render(h, params) {
            let time = params.row.originalIssueTime;
            return <span>{filter.filterTime(time, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 150
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3)) {
              return <span>团队长基础管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4) {
              return <span>限时活动加费</span>;
            } else if (commissionType == 5 && owerType == 3) {
              return <span>后置费用</span>;
            } else if (commissionType == 5 && owerType == 2) {
              return <span>团队长后置管理费</span>;
            }
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用(元)',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 180,
          slot: 'commissionPrice'
        }
      ],
      columns1: [
        {
          title: '业务员',
          align: 'center',
          key: 'owerName',
          minWidth: 160,
          slot: 'userName_staffNo'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 180
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          }
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 120
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            const policyStatus = params.row.policyStatus;
            if (policyStatus == 1) {
              return <span>已承保</span>;
            } else if (policyStatus == -1) {
              return <span>已退保</span>;
            } else if (policyStatus == 0) {
              return <span>已终止</span>;
            } else if (policyStatus == 2) {
              return <span>已中止</span>;
            }
          }
        },
        {
          title: '结算状态',
          align: 'center',
          minWidth: 100,
          render(h, params) {
            let settlementStatus = params.row.settlementStatus;
            if (settlementStatus == 1) {
              return <span>已结算</span>;
            } else {
              return <span>待结算</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '起保日期',
          align: 'center',
          key: 'startTime',
          minWidth: 130,
          render(h, params) {
            let startTime = params.row.startTime;
            return <span>{filter.filterTime(startTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '终保日期',
          align: 'center',
          key: 'endTime',
          minWidth: 130,
          render(h, params) {
            let endTime = params.row.endTime;
            return <span>{filter.filterTime(endTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '实收日期',
          align: 'center',
          key: 'payTime',
          minWidth: 130,
          render(h, params) {
            let payTime = params.row.payTime;
            return <span>{filter.filterTime(payTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '原保单承保日期',
          align: 'center',
          key: 'originalIssueTime',
          minWidth: 130,
          render(h, params) {
            let time = params.row.originalIssueTime;
            return <span>{filter.filterTime(time, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 150
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const owerType = params.row.owerType;
            const commissionType = params.row.commissionType;
            if (owerType == 2 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用管理费</span>;
            } else if (owerType == 3 && (commissionType == 1 || commissionType == 3)) {
              return <span>基础费用</span>;
            } else if (commissionType == 2 || commissionType == 4) {
              return <span>限时活动加费</span>;
            } else if (commissionType == 5 && owerType == 3) {
              return <span>后置费用</span>;
            } else if (commissionType == 5 && owerType == 2) {
              return <span>后置费用管理费</span>;
            }
          }
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 100,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用(元)',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 180,
          slot: 'commissionPrice'
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 200
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        }
      ]
    };
  },
  activated() {
    const { reportId, tabVal, orgId, userId } = this.$route.query;
    this.reportId = reportId;
    this.tabVal = tabVal;
    this.orgId = orgId;
    this.userId = userId;
    if (this.tabVal == 1) {
      this.columns = this.columns1;
    } else {
      this.columns = this.columns2;
    }
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      let data = {
        reportId: this.reportId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$http({
        url: '/buz/userSettlementDetail/getDetail',
        type: 'POST',
        data
      })
        .then(res => {
          this.data = res.data;
          this.tableData = (res.data.dataList && res.data.dataList.records) || [];
          this.total = res.data.dataList.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    exportDetailData() {
      if (!this.$units.pointAction('offline_81_3_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let data = {
        reportId: this.reportId
      };
      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/exportDetail', data, 'POST');
    }
  }
};
</script>

<style lang="scss" scoped>
.export {
  margin-bottom: 20px;
}

.back-btn {
  position: absolute;
  right: 20px;
}

.statistics-container {
  display: flex;

  .statistics-item {
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      margin-right: 60px;
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;

      .num {
        color: #ff7134;
      }
    }
  }
}

.table {
  .tr {
    border: 1px solid #e8eaec;
    border-right: none;
    border-top: none;
    text-align: center;
    height: 40px;
    line-height: 40px;
    display: flex;

    .td {
      flex: 1;
      border-right: 1px solid #e8eaec;
      font-size: 14px;
      color: #515a6e;
      display: flex;
      justify-content: center;

      span {
        display: block;
        text-align: left;
        max-width: 180px;
        min-width: 180px;
      }
    }
  }

  .tr-first {
    border-top: 1px solid #e8eaec;
  }
}

.table-box {
  margin-top: 20px;
  .name-status {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /deep/ .user-box {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-left: 10px;
      .dian {
        display: inline-block;
        flex-shrink: 0;
        width: 5px;
        height: 5px;
        background: #35bf3f;
        border-radius: 50%;
        margin-right: 4px;
        &.red {
          background: #e3461f;
        }
      }
      &.text {
        color: #515c6f;
      }
      .user-name {
        font-size: 13px;
        &.dashed {
          border-bottom: 1px dashed #236dff;
        }
        &.line {
          border-bottom: 1px solid #236dff;
        }
      }
      i {
        color: #bababa;
        font-size: 13px;
      }
      .iconduichang {
        margin-left: 4px;
      }
      &.no-token {
        color: #515c6f;
        .user-name {
          cursor: auto;
        }
      }
    }
  }
  .commission-price {
    display: flex;
    align-items: center;
    justify-content: center;
    .text-tag {
      margin-left: 5px;
      width: 34px;
      height: 20px;
      border-radius: 2px;
      font-size: 12px;
      color: #ff7f00;
      border: 1px solid #ffcf8e;
      background: #fff3e3;
    }
  }
}
</style>
